export default "__VITE_ASSET__2fd92103__"